import {
  boolean,
  type InferOutput,
  number,
  object,
  optional,
  string
} from 'valibot'

import {
  createSorterSchema,
  DC_USERS_SORT_KEYS
} from '@/features/shared/models'

export const DcUsersSearchSchema = object({
  page: optional(number()),
  take: optional(number()),
  ...createSorterSchema(DC_USERS_SORT_KEYS),
  displayName: optional(string()), // ユーザー名
  dcId: optional(number()), // 拠点
  enable: optional(boolean()) // 有効・無効
})

export type DcUsersSearch = InferOutput<typeof DcUsersSearchSchema>
